import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {actions} from '../../actions';

import Row from './Row';
import CellStretch from './CellStretch';
import CellFixed from './CellFixed';
import FlexTable from './FlexTable';

import './Rubrics.css';
import RubricList from './RubricsList';

import IconButton from '@material-ui/core/IconButton';
import {AddCircle, RemoveCircle, Delete as DeleteIcon} from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const critWidth = "200px";
const ptsWidth = "100px";
const btnCellWith = "16px";

const RUBRICS_HEADER_ROW = ["Criteria", "Ratings", "Max Pts", ""];

const DEFAULT_CRITERION = {
    criteria_title: "New Criterion",
    ratings: [
        {rating_title: "No Marks", rating_description: "Describe your lowest rating here", points: 0},
        {rating_title: "Full Marks", rating_description: "Describe your highest rating here", points: 5}
    ],
    max_points: 5
};

const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

const styles = theme => ({
    root: {
        // width: '100%',
        // marginTop: '10px',
        // overflowX: 'auto',
        display: 'flex',
        // justifyContent: 'center',
        alignItems: 'flex-end',
    },
    paper: {
        width: '100%',
        height: '100%',
    },
    table: {
        // minWidth: 700,
    },
    button: {
        margin: theme.spacing.unit,
    }
});


class Rubrics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            naMap: [false]
        };
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleClickOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    averageNewCellValue = (leftVal, rightVal) => {
        return Math.round((leftVal + rightVal) / 2);
    };


    forceRange = (min, max, currVal) => {
        if (min && currVal < min)
            return min;
        if (max && currVal > max)
            return max;
        return currVal;
    };

    getMin = (rowInd, colInd) => {
        return colInd - 1 >= 0 ? this.props.rows[rowInd].ratings[colInd - 1].points + 1 : 0;
    };

    getMax = (rowInd, colInd) => {
        // console.log("this.props.rows: ", this.props.rows);
        // console.log("getMax() rowInd, colInd: ", rowInd + ", " + colInd);
        const lastRatingInd = this.props.rows[rowInd].ratings.length - 1;
        return lastRatingInd <= colInd ? this.props.rows[rowInd].ratings[lastRatingInd].points + 1 : this.props.rows[rowInd].ratings[colInd + 1].points - 1;
    };

    handlePointsOnBlur = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const min = parseInt(e.target.getAttribute("min"));
        const rows = [...this.props.rows];
        const ratingsLength = rows[rowInd].ratings.length;
        const newPts = this.forceRange(min, null, parseInt(e.target.value));

        rows[rowInd].max_points = newPts;
        // update the last item of rubrics to have it equal
        rows[rowInd].ratings[ratingsLength - 1].points = newPts;
        this.props.updateRubrics(rows);
    };

    handleRatingsOnBlur = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const colInd = parseInt(e.target.getAttribute("col"));
        const min = parseInt(e.target.getAttribute("min"));
        const max = parseInt(e.target.getAttribute("max"));
        const rows = [...this.props.rows];
        const ratingsLength = rows[rowInd].ratings.length;
        const newRatings = [...this.props.rows[rowInd].ratings];
        const newValue = this.forceRange(min, max, parseInt(e.target.value));

        newRatings[colInd].points = newValue;
        rows[rowInd].ratings = newRatings;
        // update the points if the last item of ratings was changed
        if (colInd === ratingsLength - 1) {
            rows[rowInd].max_points = newValue;
        }
        this.props.updateRubrics(rows);
    };

    handleCriteriaChange = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const rows = [...this.props.rows];
        const newCriteria = e.target.value;

        rows[rowInd].criteria_title = newCriteria;
        this.props.updateRubrics(rows);
    };

    handleRatingTitleChange = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const colInd = parseInt(e.target.getAttribute("col"));
        const rows = [...this.props.rows];
        const ratings = [...this.props.rows[rowInd].ratings];
        const newRatingTitle = e.target.value;

        ratings[colInd].rating_title = newRatingTitle;
        rows[rowInd].ratings = ratings;
        this.props.updateRubrics(rows);
    };

    handleRatingDescriptionChange = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const colInd = parseInt(e.target.getAttribute("col"));
        const rows = [...this.props.rows];
        const ratings = [...this.props.rows[rowInd].ratings];
        const newRatingDescription = e.target.value;

        ratings[colInd].rating_description = newRatingDescription;
        rows[rowInd].ratings = ratings;
        this.props.updateRubrics(rows);
    };

    handlePointsChange = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const rows = [...this.props.rows];
        const ratingsLength = rows[rowInd].ratings.length;
        const newPts = parseInt(e.target.value);
        rows[rowInd].max_points = newPts;
        // update the last item of rubrics to have it equal
        rows[rowInd].ratings[ratingsLength - 1].points = newPts;
        this.props.updateRubrics(rows);
    };

    updateRatingChange(rowInd, colInd, newVal) {
        const rows = [...this.props.rows];
        const ratingsLength = rows[rowInd].ratings.length;
        const newRatings = [...this.props.rows[rowInd].ratings];

        newRatings[colInd].points = newVal;
        rows[rowInd].ratings = newRatings;
        // update the points if the last item of ratings was changed
        if (colInd === ratingsLength - 1) {
            rows[rowInd].max_points = newVal;
        }
        this.props.updateRubrics(rows);
    }

    handleRatingChange = (e) => {
        const rowInd = parseInt(e.target.getAttribute("row"));
        const colInd = parseInt(e.target.getAttribute("col"));
        const newVal = parseInt(e.target.value);
        this.updateRatingChange(rowInd, colInd, newVal);
    };

    handleAddNewCell = (e) => {
        e.preventDefault();
        const rowInd = parseInt(e.currentTarget.getAttribute("row"));
        const colInd = parseInt(e.currentTarget.getAttribute("col"));

        const lastRatingInd = this.props.rows[rowInd].ratings.length - 1;
        const firstRatingPoints = this.props.rows[rowInd].ratings[0].points;

        if (colInd !== -1) {
            const leftVal = this.props.rows[rowInd].ratings[colInd].points;
            const rightVal = colInd === lastRatingInd ? this.props.rows[rowInd].ratings[lastRatingInd].points + 1 : this.props.rows[rowInd].ratings[colInd + 1].points;
            const newAveragedVal = this.averageNewCellValue(leftVal, rightVal);

            // console.log("leftVal: ", leftVal);
            // console.log("rightVal: ", rightVal);
            // console.log("newAveragedVal: ", newAveragedVal);

            if (newAveragedVal > leftVal) {
                if (colInd === lastRatingInd || newAveragedVal < rightVal) {
                    const rows = [...this.props.rows];
                    const newRatings = [...this.props.rows[rowInd].ratings];
                    const insertAt = (colInd + 1);
                    newRatings.splice(insertAt, 0, {
                        rating_title: "Rating Title",
                        rating_description: "Enter your rating description here",
                        points: newAveragedVal
                    });
                    rows[rowInd].ratings = newRatings;
                    this.props.updateRubrics(rows);
                    this.updateRatingChange(rowInd, colInd + 1, newAveragedVal);
                }

            }
        } else if (firstRatingPoints > 0) {
            const leftVal = firstRatingPoints - 1;
            const rightVal = firstRatingPoints;


            const rows = [...this.props.rows];
            const newRatings = [...this.props.rows[rowInd].ratings];
            newRatings.splice(0, 0, {
                rating_title: "Rating Title",
                rating_description: "Enter your rating description here",
                points: leftVal
            });
            rows[rowInd].ratings = newRatings;
            this.props.updateRubrics(rows);
        } else {
            //add na column here
            if(!this.state.naMap[rowInd]) {
                const leftVal = -1;
                const rightVal = firstRatingPoints;


                const rows = [...this.props.rows];
                const newRatings = [...this.props.rows[rowInd].ratings];
                newRatings.splice(0, 0, {
                    rating_title: "Not Applicable",
                    rating_description: "Enter your rating description here",
                    points: leftVal,
                    na: true
                });
                rows[rowInd].ratings = newRatings;
                this.props.updateRubrics(rows);
                let newNaMap = this.state.naMap;
                newNaMap[rowInd] = true;
                this.setState({naMap: newNaMap})
            }
        }


    };

    handleRemoveCell = (e) => {
        e.preventDefault();
        const rowInd = parseInt(e.currentTarget.getAttribute("row"));
        const colInd = parseInt(e.currentTarget.getAttribute("col"));

        const newRatings = [...this.props.rows[rowInd].ratings];
        // make sure there are at least 2 cells for min and max
        if (newRatings.length > 2) {
            const removeAt = colInd;
            newRatings.splice(removeAt, 1);
            const rows = [...this.props.rows];
            rows[rowInd].ratings = newRatings;
            this.props.updateRubrics(rows);
            if (colInd - 1 === newRatings.length - 1) {
                const maxPoints = newRatings[newRatings.length - 1].points;
                this.updateRatingChange(rowInd, colInd - 1, maxPoints);
            }
            if(colInd == 0) {
                let newNaMap = this.state.naMap;
                newNaMap[rowInd] = false;
                this.setState({naMap: newNaMap});
            }
        }
    };

    handleRemoveRow = (e) => {
        e.preventDefault();
        const rows = [...this.props.rows];
        rows.splice(parseInt(e.currentTarget.getAttribute("row")), 1);
        this.props.updateRubrics(rows);
    };

    handleAddNewRow = () => {
        const rows = [...this.props.rows, deepCopy(DEFAULT_CRITERION)];
        this.props.updateRubrics(rows);
    };

    handleDuplicateLastRow = () => {
        if (this.props.rows.length > 0) {
            let lastRow = this.props.rows[this.props.rows.length - 1];
            const rows = [...this.props.rows, deepCopy(lastRow)];

            this.props.updateRubrics(rows);

            let newNaMap = this.state.naMap;
            if(lastRow.ratings[0].na) {
                newNaMap[newNaMap.length] = true;
            } else {
                newNaMap[newNaMap.length] = false;
            }
            this.setState({naMap: newNaMap});
        }
    };

    renderHeaderRow = () => {
        return (
            <Row>
                <CellFixed className="cellHeader" width={critWidth}>{RUBRICS_HEADER_ROW[0]}</CellFixed>
                <CellStretch className="cellHeader">{RUBRICS_HEADER_ROW[1]}</CellStretch>
                <CellFixed className="cellHeader" width={ptsWidth}>{RUBRICS_HEADER_ROW[2]}</CellFixed>
                <CellFixed className="cellHeader" width={btnCellWith}>{RUBRICS_HEADER_ROW[3]}</CellFixed>
            </Row>
        );
    };

    renderSetPts(rating, i,j) {
        if(!rating.na) {
            return(
                <div>
                    <label>Set Pts: </label>
                    <input type="number" style={{display: 'inline'}}
                           min={this.getMin(i, j)}
                           max={this.getMax(i, j)}
                           value={rating.points}
                           onChange={this.handleRatingChange}
                           onBlur={this.handleRatingsOnBlur}
                           disabled={this.props.disabled}
                           row={i}
                           col={j}/>
                </div>
            )
        } else {
            return(
                null
            )

        }
    }

    renderPlusButton(styleFirstPlusButton, i) {
        if(this.state.naMap[i]){
            return null;
        } else {
            return( <CellFixed>
                <div style={styleFirstPlusButton}>
                    <button className="btn" hidden={this.props.disabled} onClick={this.handleAddNewCell}
                            row={i} col={-1}>
                        <AddCircle color="secondary"/>
                    </button>
                </div>
            </CellFixed>)
        }
    }

    renderRows = (rows) => {
        const styleFirstPlusButton = {
            width: "1.5em",
            // marginLeft: 0,
            marginRight: "5px",
        };
        const styleButton = {
            width: "1.5em",
            // marginRight: "1em",
            // marginLeft: 0,
            // marginRight: 0,
            // padding: "3px",
            // margin: "3px",
            // borderColor: "#ffffff"
        };
        const styleCell = {
            padding: "5px"
        };
        return rows.map((row, i) => {
            const criteriaCell = (
                <CellFixed width={critWidth}>
                    <textarea rows="3"
                              value={row.criteria_title}
                              onChange={this.handleCriteriaChange}
                              disabled={this.props.disabled}
                              row={i}/>
                </CellFixed>
            );
            const plusButtonCell = this.renderPlusButton(styleFirstPlusButton, i);
            const ratingsLength = row.ratings.length;
            const mappedCells = row.ratings.map((rating, j) => {
                return (
                    <CellStretch key={j} style={styleCell}>
                        <div style={{width: "100%", padding: "5px"}}>
                                    <textarea rows={"1"} value={rows[i].ratings[j].rating_title}
                                              disabled={this.props.disabled}
                                              onChange={this.handleRatingTitleChange} row={i} col={j}/>
                            <textarea rows={"2"} value={rows[i].ratings[j].rating_description}
                                      disabled={this.props.disabled}
                                      onChange={this.handleRatingDescriptionChange} row={i} col={j}/>
                            {this.renderSetPts(rating, i,j)}

                        </div>
                        <div style={styleButton}>
                            <button className="btn" hidden={this.props.disabled} onClick={this.handleAddNewCell}
                                    row={i} col={j}>
                                <AddCircle color="secondary"/>
                            </button>
                            <button className="btn" hidden={this.props.disabled} onClick={this.handleRemoveCell}
                                    row={i} col={j}>
                                <RemoveCircle color="secondary"/>
                            </button>
                        </div>
                    </CellStretch>
                );
            });
            const ptsCell = (
                <CellFixed width={ptsWidth}>
                    <input type="number"
                           disabled={this.props.disabled}
                           min={this.getMin(i, ratingsLength - 1)}
                           value={row.max_points}
                           onChange={this.handlePointsChange}
                           onBlur={this.handlePointsOnBlur}
                           row={i}/>
                </CellFixed>
            );

            const removeRowButton = <IconButton className={this.props.classes.button} aria-label="Delete"
                                                onClick={this.handleRemoveRow} row={i}>
                <DeleteIcon/>
            </IconButton>;

            if (this.props.disabled) {
                return (
                    <div key={i}>
                        <Row>
                            {criteriaCell}{mappedCells}{ptsCell}
                        </Row>
                    </div>
                );
            } else {
                return (
                    <div key={i}>
                        <Row>
                            {criteriaCell}{plusButtonCell}{mappedCells}{ptsCell}{removeRowButton}
                        </Row>
                    </div>
                );
            }

        });
    };

    showSaveButton() {
        if(this.props.showSave) {
            return (<Button variant="contained" color="secondary" className={this.props.classes.button}
                            onClick={this.props.handleSave}>
                Save Rubric
            </Button>)
        }

    }

    showImportButton() {
        if(this.props.showImport) {
            return (
                    <Button variant="contained" color='secondary' className={this.props.classes.button} onClick={this.handleClickOpen}>Import Rubric</Button>
            )
        }

    }

    handleSelect(row) {
        this.props.updateRubrics(row.criterions);
        let newNaMap = [];
        for(var i = 0; i < row.criterions.length; i++) {
            if(row.criterions[0].ratings[0].na) {
                newNaMap[i] = true;
            } else {
                newNaMap[i] = false;
            }
        }
        this.setState({naMap: newNaMap});
        this.handleClose();
    };

    renderImport() {
        if(this.props.showImport) {
            this.props.fetchRubrics(this.props.form.outcome.id);
            return(<div>
                <Dialog
                    fullScreen={false}
                    scroll='paper'
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    maxWidth={false}
                    classes={{
                        paper: this.props.classes.paper,
                    }}
                >
                    <DialogTitle id="responsive-dialog-title">Import Rubric</DialogTitle>
                    <DialogContent>
                        <RubricList handleSelect={this.handleSelect} showActions={false}/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="secondary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>)
        }

    }

    render() {
        if (this.props.disabled) {
            return (
                <div>
                    <FlexTable>
                        {this.renderHeaderRow()}
                        {this.renderRows(this.props.rows)}
                    </FlexTable>
                </div>
            );
        } else {
            return (
                <div>
                    <FlexTable>
                        {this.renderHeaderRow()}
                        {this.renderRows(this.props.rows)}
                        <Button variant="contained" color="secondary" className={this.props.classes.button}
                                onClick={this.handleAddNewRow}>
                            Add New Criterion
                        </Button>
                        <Button variant="contained" color="secondary" className={this.props.classes.button}
                                onClick={this.handleDuplicateLastRow}>
                            Duplicate Last Criterion
                        </Button>
                        {this.showSaveButton()}
                        {this.showImportButton()}
                        {this.renderImport()}
                    </FlexTable>
                </div>
            );
        }

    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        rows: state.rubrics
    }
}

export default connect(mapStateToProps, actions)(withStyles(styles)(Rubrics));
